import { Play, X, Star } from "lucide-react";
import { getMoodMeta } from "../lib/moods";

export default function Favorites({ items, onLaunch, onDelete, disabled }) {
  if (!items.length) return null;
  return (
    <section className="mt-10">
      <h2 className="font-extrabold text-2xl tracking-tight mb-4 flex items-center gap-2">
        <Star className="h-5 w-5 text-[#FF2E93]" fill="#FF2E93" /> Mes favoris
      </h2>
      <div data-testid="favorites-list" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {items.map((f) => (
          <div key={f.id} className="group sp-card rounded-md flex items-center overflow-hidden">
            <div className="h-16 w-16 shrink-0 flex items-center justify-center text-2xl" style={{ background: getMoodMeta(f).color }}>
              {f.custom_mood ? "🪩" : getMoodMeta(f).emoji}
            </div>
            <button
              data-testid={`favorite-launch-${f.id}`}
              disabled={disabled}
              onClick={() => onLaunch(f)}
              className="flex-1 min-w-0 text-left px-4 py-2 disabled:opacity-40"
            >
              <div className="font-bold text-sm truncate">{f.name}</div>
              <div className="text-xs text-[#B3B3B3] truncate">
                {f.duration_minutes} min{f.mood2 ? ` · mix ${100 - f.blend}/${f.blend}` : ""}{f.exclude_recent ? " · sans récents" : ""}
              </div>
            </button>
            <button
              data-testid={`favorite-delete-${f.id}`}
              onClick={() => onDelete(f.id)}
              className="p-2 text-[#6a6a6a] hover:text-white md:opacity-0 md:group-hover:opacity-100 transition-opacity"
              title="Supprimer"
            >
              <X className="h-4 w-4" />
            </button>
            <button
              onClick={() => onLaunch(f)}
              disabled={disabled}
              className="mr-3 h-10 w-10 rounded-full bg-[#FF2E93] flex items-center justify-center shrink-0 md:opacity-0 md:group-hover:opacity-100 transition-opacity"
              tabIndex={-1}
            >
              <Play className="h-4 w-4 text-black ml-0.5" fill="black" />
            </button>
          </div>
        ))}
      </div>
    </section>
  );
}
